export const supportPageLangMap = {
  en: 'en-us',
  'zh-hant': 'zh-tw',
  'zh-cn': 'zh-cn',
  ja: 'ja',
} as const;

export type SupportPageLangKey = keyof typeof supportPageLangMap;
